export default __webpack_public_path__ + "static/principle-integrated-dark-38e2c8f5545892e6baac150dc00ab75b2690477de2208637edf2c78fe7d7f384.png";